import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'redux'

import { useAppContext } from '@/App.context'
import { useText } from '@/components/i18n/hooks'
import { Translation } from '@/components/i18n/Translation'
import { STEP_ACCESSORIES_ALL } from '@/ducks/onboarding/constants'
import {
  goToStep,
  setWorkType,
  WORK_TYPE_OFFICE,
  WORK_TYPE_PROFESSIONAL,
} from '@/ducks/onboarding/onboardingActions'
import { getOnboardingUserType } from '@/ducks/onboarding/onboardingSelectors'

import './step-work-type.scss'

const StepWorkType = ({ setWorkType, goToStep }: any) => {
  const APPLICATIONS_MANAGER = useText('WORK_TYPE_OFFICE/programmer').split('|')
  const APPLICATIONS_PROFESSIONAL = useText('WORK_TYPE_PROFESSIONAL/programmer').split('|')

  const { whiteLabel } = useAppContext()

  return (
    <div id="step-work-type" className="step">
      <h3>
        <Translation id="Jeg trenger kun tilbehør" />
      </h3>

      <button
        onClick={() => goToStep(STEP_ACCESSORIES_ALL)}
        className={`go-to-accessories ${whiteLabel}`}
      >
        <Translation id="Gå til tilbehør" />
      </button>

      <h3>
        <Translation id="Velg type arbeid" />
      </h3>

      <p>
        <Translation id="Din PC vil leveres med programpakke tilpasset ditt behov" />
      </p>

      <p>
        <Translation id="For å sikre at du velger riktig PC" />
      </p>

      <div className="options">
        <div className="option">
          <h2>
            <Translation id="WORK_TYPE_OFFICE/oppgaver" />
          </h2>

          <h4>
            <Translation id="Typiske programmer" />
          </h4>

          <ul>
            {APPLICATIONS_MANAGER.map(p => (
              <li key={p}>{p}</li>
            ))}
          </ul>

          <button onClick={() => setWorkType(WORK_TYPE_OFFICE)} className={whiteLabel}>
            <Translation id="Velg dette" />
          </button>
        </div>

        <div className="option">
          <h2>
            <Translation id="WORK_TYPE_PROFESSIONAL/oppgaver" />
          </h2>

          <h4>
            <Translation id="Typiske programmer" />
          </h4>

          <ul>
            {APPLICATIONS_PROFESSIONAL.map(p => (
              <li key={p}>{p}</li>
            ))}
          </ul>

          <button onClick={() => setWorkType(WORK_TYPE_PROFESSIONAL)} className={whiteLabel}>
            <Translation id="Velg dette" />
          </button>
        </div>
      </div>
    </div>
  )
}

// @ts-ignore
const mapStateToProps = state => ({
  userType: getOnboardingUserType(state),
})

const mapDispatchToProps = {
  setWorkType,
  goToStep,
}

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(StepWorkType)
